import { EquipmentLabelsService } from "@/common/api.service"
import { FETCH_EQUIPMENT_LABEL,ADD_EQUIPMENT_LABEL_DATA, RESET_STATE } from "./actions.type"
import { SET_EQUIPMENT_LABEL, SET_ERROR_EQUIPMENT_LABEL, STATE_RESET  } from "./mutations.type"

const initialState = () => {
    return {
        equipmentlabeldata: [],
        equipmentlabelerrors: null,
    }
}

let state = initialState()

const getters = {
    equipmentlabeldata(state) {
        return state.equipmentlabeldata
    }
}

const actions = {
    async [FETCH_EQUIPMENT_LABEL](context, slug) {
        const { data } = await EquipmentLabelsService.get(slug)
        context.commit(SET_EQUIPMENT_LABEL, data.data)
        return data;
    },
    async [ADD_EQUIPMENT_LABEL_DATA](context, payload) {
        return await EquipmentLabelsService.create(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_EQUIPMENT_LABEL, error.response.data.errors)
        });
    }, 
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = { 
    [SET_ERROR_EQUIPMENT_LABEL](state, error) {
        state.equipmentlabelerrors = error
    },    

    [SET_EQUIPMENT_LABEL](state, equipmentlabel) {
        state.equipmentlabeldata = equipmentlabel
    },  
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};